import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { alert_error, alert_success } from './../../AppContext';
import { Cookies } from './../../index.js';
import QRCode from "qrcode.react";
import { ClipLoader } from "react-spinners";
import Post_content from '../../community/content/Blog_posts.jsx';
import Language_i18 from '../../js/useNationalLanguage.jsx';
import translations from './translations.json'; // Đổi tên để tránh trùng lặp

const InviteFriends = () => {
  // THAY ĐỔI 1: Nhận cả `lang` và `translations` từ hook
  const { i18n, lang } = Language_i18();
  const { slug_1 } = useParams();
  const [profile, setprofile] = useState('');
  const [link_ref, setlink_ref] = useState('');
  const qrCodeStyle = {
    backgroundColor: "#ff69b4",
  };

  // --- LOGIC GỐC CỦA BẠN (KHÔNG THAY ĐỔI) ---
  const laythongtin = (apikey, service) => {
    axios
      .post('https://hust.media/jop/referral/getinfo.php', { apikey, service })
      .then(response => testFunction4(response, service))
      .catch(error => console.log(123 + error));
  };
  const testFunction4 = (response, service) => {
    if (service === 'getinfo') {
      const apiKey = Cookies.get('apikey');
      const info = response.data;
      if (info?.iduser) {
        laythongtin(apiKey, 'count');
        const dynamicLink = `https://hust.media/thankskiu/${info.iduser}`;
        setlink_ref(dynamicLink);
      }
    } else if (service === 'count') {
      const info = response.data;
      if (info) {
        setprofile(info);
      }
    }
  };
  const laydulieu = () => {
    const apiKey = Cookies.get('apikey');
    if (apiKey) {
      laythongtin(apiKey, 'getinfo');
    } else {
      console.log('Không có API key.');
    }
  };
  useEffect(() => {
    laydulieu();
  }, []);

  // THAY ĐỔI 2: SỬ DỤNG CÚ PHÁP `translations[lang]?.key`
  function saochep(value) {
    alert_success(translations[lang]?.copiedSuccess);
    window.saochepnative(value);
  };
  function share(value) {
    alert_success(translations[lang]?.copiedSuccess);
    window.saochepnative(value);
  };
  const handleShareButtonClick = async (value) => {
    try {
      await navigator.share({ title: 'hust.media', url: value });
    } catch (error) {
      console.error('Lỗi khi chia sẻ:', error);
    }
  };

  const affRateValue = profile?.aff_rate !== undefined && profile?.aff_rate !== null
    ? `${profile.aff_rate}%`
    : '0%';
  
  // KIỂM TRA NẾU DỮ LIỆU DỊCH CHƯA SẴN SÀNG
  if (!translations) {
    return <div style={{ textAlign: "center" }} className="mt-4"><ClipLoader size={90} color="#8a2be2" /></div>;
  }

  return (
    <div className="mb-3 mt-2">
      {!link_ref ? (<>
        <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
          <ClipLoader size={90} color="#8a2be2" />
        </div>
      </>) : (<>
        <div className="max-w-4xl mx-auto">
          <div className="mt-2 mx-2 grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="bg-white rounded-md shadow-md md:col-span-3">
              <Post_content mode={'hust_media'} show_adsense={'NO'} show_adskeeper={'NO'} uri={'referrals_hust'} />
              <div className="px-4 mt-1 mb-4">
                <p className="text-gray-700 mb-2">{translations[lang]?.shareYourLink}</p>
                <div className="flex flex-row">
                  <input
                    className="border border-gray-300 rounded-md px-2 mb-2 w-full"
                    type="text"
                    value={link_ref}
                    readOnly
                  />
                  <button onClick={() => saochep(link_ref)} className="bg-transparent hover:bg-blue-100  text-blue-500 font-semibold px-1 rounded-md border-1 border-red-400">
                    {translations[lang]?.copy}
                  </button>
                  <button onClick={() => handleShareButtonClick(link_ref)} className="bg-transparent hover:bg-blue-100 text-blue-500 font-semibold px-1 rounded-md border-1 border-green-500">
                    {translations[lang]?.share}
                  </button>
                </div>
              </div>
            </div>
            <div className="bg-white p-3 rounded-md shadow-md md:col-span-2">
              {!profile ? (<>
                <div style={{ textAlign: "center" }} className="mt-2 text-center items-center">
                  <ClipLoader size={70} color="#8a2be2" />
                </div>
              </>) : (<>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-100 p-2 rounded-md shadow-md border-1 border-purple-300">
                    <h2 className="text-lg font-semibold mb-1">{translations[lang]?.totalReferrals}</h2>
                    <p className="text-center text-lg text-purple-700">{profile.total_referrals} {translations[lang]?.people}</p>
                  </div>
                  <div className="bg-gray-100 p-2 rounded-md shadow-md border-1 border-pink-300">
                    <h2 className="text-lg font-semibold mb-1">{translations[lang]?.totalCoinsEarned}</h2>
                    <p className="text-center text-lg text-pink-700">{profile.count_earn_money} Coins</p>
                  </div>
                  <div className="bg-gray-100 p-2 rounded-md shadow-md border-1 border-blue-300">
                    <h2 className="text-lg font-semibold mb-1">{translations[lang]?.referralRate}</h2>
                    <p className="text-center text-lg text-blue-700">{affRateValue}</p>
                  </div>
                  <div className="bg-gray-100 p-2 rounded-md shadow-md border-1 border-rose-300">
                    <h2 className="text-lg font-semibold mb-1">{translations[lang]?.increaseRate}</h2>
                    <p className="text-center text-base text-rose-700">{translations[lang]?.pleaseMessageAdmin}</p>
                  </div>
                </div>
                <div className="mt-1 text-center">
                  <h5 className="bold mb-0 text-base text-pink-500">
                    {translations[lang]?.referWithQR}
                  </h5>
                  <div className="d-flex justify-content-center mb-2 mt-1">
                    <QRCode
                      includeMargin={true}
                      fgColor="#FFFFFF"
                      bgColor="#ff69b4"
                      size={256}
                      renderAs="svg"
                      style={qrCodeStyle}
                      value={link_ref}
                    />
                  </div>
                </div>
              </>)}
            </div>
          </div>
        </div>
      </>)}
    </div>
  );
};

export default InviteFriends;
